import React from 'react'
import { useStyles } from './screen-overlay.styles'

export const ScreenOverlay = () => {
  const styles = useStyles()

  return <div className={styles.container} />
}
